import axiosClient from "../axiosClient";

const modulesApi = {
  createModules: (params) => {
    const url = "setting/update-module";
    return axiosClient.post(url, params);
  },

  getBannerTop: () => {
    const url = "setting/get-module/top-banner";
    return axiosClient.get(url);
  },

  getHomeFeaturedProductsSlider: () => {
    const url = "setting/get-module/home-featured-products-slider";
    return axiosClient.get(url);
  },

  getHomeFeaturedBanner: () => {
    const url = "setting/get-module/home-featured-banner";
    return axiosClient.get(url);
  },

  getHomeFeaturedProduct: () => {
    const url = "setting/get-module/home-featured-product";
    return axiosClient.get(url);
  },

  getHomePromotionalProducts: () => {
    const url = "setting/get-module/home-promotional-products";
    return axiosClient.get(url);
  },

  getHomeIntroduction: () => {
    const url = "setting/get-module/home-introduction";
    return axiosClient.get(url);
  },
  getStockAddressDefault: () => {
    const url = "setting/get-module/stock-address-default";
    return axiosClient.get(url);
  },

  getWebSettings: () => {
    const url = "setting/get-module/web-settings";
    return axiosClient.get(url);
  },

  getPaymentMethod: () => {
    const url = "setting/get-module/payment-method";
    return axiosClient.get(url);
  },


  getDefaultPageSeo: (payload) => {
    const url = "setting/get-module/default-page-seo";
    return axiosClient.get(url, {
      params: payload,
    });
  },


};

export default modulesApi;
